<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab21.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab21.text1") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab21.text2") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text disc">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">info</span>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab21.text3', $t, localPath)"></span></p>
                                        <ul class="sub-cont">
                                        <li>
                                            <p class="body-4"><span >{{ $t("faq.tab21.text4") }}</span></p>
                                        </li>
                                        <li>
                                            <p class="body-4"><span >{{ $t("faq.tab21.text5") }}</span></p>
                                        </li>
                                        </ul>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab21.text6") }}</span></p>
                                        <div class="buttons sub-cont">
                                        <a :href="getExternalUrl('/login')" target="_blank" rel="noopener noreferrer">
                                        <button class="primary-button-medium">
                                            {{ $t("faq.tab21.btn") }}
                                        </button>
                                        </a>
                                        </div>
                                        <p class="body-4"><span v-html="formatContent('faq.tab21.text7', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                    <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab21.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab21.text1") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab21.text2") }}</span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text disc">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">info</span>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab21.text3', $t, localPath)"></span></p>
                                    <ul class="sub-cont">
                                    <li>
                                        <p class="body-4"><span >{{ $t("faq.tab21.text4") }}</span></p>
                                    </li>
                                    <li>
                                        <p class="body-4"><span >{{ $t("faq.tab21.text5") }}</span></p>
                                    </li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab21.text6") }}</span></p>
                                    <div class="buttons sub-cont">
                                    <a :href="getExternalUrl('/login')" target="_blank" rel="noopener noreferrer">
                                    <button class="primary-button-medium">
                                        {{ $t("faq.tab21.btn") }}
                                    </button>
                                    </a>
                                    </div>
                                    <p class="body-4"><span v-html="formatContent('faq.tab21.text7', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
import { useExternalUrl } from '@/composables/useExternalUrl';
const { getExternalUrl } = useExternalUrl();

const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab21.title1", "faq.tab21.text1");
</script>
